import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as LogoIcon } from '../../../../assets/images/svg/logoBriz.svg';
import PropTypes from 'prop-types';

const Logo = ({ logoClassName }) => {
  return (
    <Link to="/" aria-label="домашня сторінка" className={logoClassName}>
      <LogoIcon />
    </Link>
  );
};

Logo.propTypes = {
  logoClassName: PropTypes.string
};

export default React.memo(Logo);
